module.exports = __webpack_public_path__ + "static/media/iscte.b7af2a26.PNG";